import { useSiteSettings } from "@/hooks/content";

/** Normalizes a phone number into the digits-only international format WhatsApp needs. */
function toWaNumber(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  // Ensure international format (Cameroon is +237); prepend nothing if already long.
  return digits;
}

/**
 * Floating WhatsApp chat button. Shows only when the admin has set a WhatsApp
 * number in Website Settings; opens a wa.me chat on click.
 */
export default function FloatingWhatsApp() {
  const { record: settings } = useSiteSettings();
  const number = toWaNumber(settings.whatsapp ?? "");

  if (!number) return null;

  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 hover:bg-[#1ebe5d] transition-all"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </a>
  );
}